import { FormattedMessage } from 'react-intl';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import CoachComment from './CoachComment';
import AddCoachComment from './AddCoachComment';
import { PersonPinCircle as CoachIcon } from '@mui/icons-material';
import { useContext, useState } from 'react';
import PortfolioModeContext from '@/lib/contexts/PortfolioModeContext';
import CoachCommentsContext from './CoachCommentsContext';
import ReplyIndicator from './ReplyIndicator';
import clsx from 'clsx';
import CoachCommentListWrapper from './CoachCommentListWrapper';
import CoachCommentListTitle from './CoachCommentListTitle';
import isTouchDevice from '@/lib/utils/isTouchDevice';
import LogEntryCoachCommentsDivider from './LogEntryCoachCommentsDivider';

const CoachComments = () => {
  const { coachComments, isInLogEntry } = useContext(CoachCommentsContext);
  const portfolioMode = useContext(PortfolioModeContext);

  const [isShowingAddForm, setIsShowingAddForm] = useState(false);

  const disableVisibilityStyling =
    !isShowingAddForm && coachComments.length === 0 && isTouchDevice();

  return (
    <>
      {isInLogEntry && (isShowingAddForm || coachComments.length > 0) && (
        <LogEntryCoachCommentsDivider />
      )}
      <CoachCommentListWrapper
        className={
          disableVisibilityStyling
            ? undefined
            : clsx(
                'coach-comment-list',
                coachComments.length === 0 && 'has-no-comments',
                portfolioMode === PortfolioMode.COACH && 'has-controls',
                isShowingAddForm && 'add-form-open',
              )
        }
        disableVisibilityStyling={disableVisibilityStyling}
        isInLogEntry={isInLogEntry}
      >
        {coachComments.length > 0 && (
          <>
            <ReplyIndicator />
            <CoachCommentListTitle>
              <CoachIcon />
              <FormattedMessage
                id={`portfolio.challenge.coach_comments.title.${coachComments.length === 1 ? 'singular' : 'plural'}`}
              />
            </CoachCommentListTitle>
          </>
        )}
        {coachComments.map(coachComment => (
          <CoachComment coachComment={coachComment} key={coachComment.id} />
        ))}
        <RestrictedToPortfolioMode mode={PortfolioMode.COACH}>
          <AddCoachComment
            onShowAddForm={() => setIsShowingAddForm(true)}
            onCloseAddForm={() => setIsShowingAddForm(false)}
            isFirstCoachComment={coachComments.length === 0}
          />
        </RestrictedToPortfolioMode>
      </CoachCommentListWrapper>
    </>
  );
};

export default CoachComments;
